import type { Locale } from "../types/domain";
export type { Locale } from "../types/domain";

export const supportedLocales: Locale[] = ["de", "en", "el"];
export function normalizeLocale(value: unknown): Locale | null {
  if (typeof value !== "string") return null;
  const base = value.toLowerCase().split("-")[0];
  return supportedLocales.includes(base as Locale) ? base as Locale : null;
}
export function detectBrowserLocale(languages: readonly string[] = typeof navigator === "undefined" ? [] : navigator.languages): Locale {
  for (const language of languages) { const locale = normalizeLocale(language); if (locale) return locale; }
  return "en";
}
export function resolveLocale(input: { pending?: unknown; claim?: unknown; stored?: unknown; browser?: readonly string[] }): Locale {
  return normalizeLocale(input.pending) ?? normalizeLocale(input.claim) ?? normalizeLocale(input.stored) ?? detectBrowserLocale(input.browser) ?? "en";
}
export function resolveTimezone(claim: unknown, browser = typeof Intl === "undefined" ? undefined : Intl.DateTimeFormat().resolvedOptions().timeZone): string {
  for (const candidate of [claim, browser, "UTC"]) {
    if (typeof candidate !== "string" || !candidate) continue;
    try { new Intl.DateTimeFormat("en", { timeZone: candidate }).format(); return candidate; } catch { /* try next */ }
  }
  return "UTC";
}
